module.exports = __webpack_public_path__ + "static/things-to-do-208b532d1d9dfaf6e1e88d8fdc4773e0.png";